import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import Container from "../components/layout/Container";
import LiveAnimalClassifiedCustomForm from "../components/LiveAnimalsCustomForm/LiveAnimalClassifiedCustomForm";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const LiveAnimalsClassifiedCustomFieldForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"Creating Acution Listing"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory />
          <LiveAnimalClassifiedCustomForm />
        </div>
      </div>
    </Container>
  );
};

export default LiveAnimalsClassifiedCustomFieldForm;
